import React,{Component} from "react";

export default class Tab extends Component{
    constructor(props) {
        super(props);
        this.tabRef = React.createRef();   // 创建一个 ref 对象
    }
    getNav = () =>{
        let {data} = this.props;
        if(data.length >1){
            return(
                <nav className="picNav">
                    {data.map((item, index)=>{
                        return (
                            <span
                                key={index}
                                className={index===0?"active":""}
                            >
                        </span>
                        );
                    })}
                </nav>
            );
        }
        return "";
    }
    componentDidMount() {
        if (this.props.data.length > 1){
            this.tabMove();
        }

    }
    tabMove=()=>{
        let tabElement = this.tabRef.current;  
        if (!tabElement) return;    
        let picList = tabElement.querySelector(".picList");
        let picNavs = tabElement.querySelectorAll(".picNav span");
        let now = 0; //记录用户切换当前显示的第几张
        let x = 0;
        let startPoint = {};
        let startX = 0;
        let isMove = false;
        let isFirst = true;
        picList.innerHTML += picList.innerHTML;
        picList.style.width = picList.children.length + "00vw";
        const touchStartHandler = (e) => {
            clearInterval(this.timer);
            picList.style.transition = "none";
            startPoint = {
                x: e.changedTouches[0].pageX,
                y: e.changedTouches[0].pageY
            };

            if(now===0){
                now = picNavs.length;
            }
            if(now===picList.children.length-1){
                now = picNavs.length -1 ;
            }
            isMove = false;
            isFirst = true;
            x = -now * tabElement.clientWidth;
            picList.style.WebkitTransform = picList.style.transform = `translate3d(${x}px,0,0)`;

            startX = x;
        };
        const touchMoveHandler = (e) => {
            let nowPoint = {
                x: e.changedTouches[0].pageX,
                y: e.changedTouches[0].pageY
            };
            let dis = {
                x: nowPoint.x - startPoint.x,
                y: nowPoint.y - startPoint.y
            };
            if (isFirst &&
                Math.abs(dis.x - dis.y) > 2){
                if(Math.abs(dis.x) > Math.abs(dis.y)){
                    isMove = true;
                }
                isFirst = false;
            }
            if(isMove){
                x = startX + dis.x;
                picList.style.WebkitTransform = picList.style.transform = `translate3d(${x}px,0,0)`;
                e.preventDefault();
            }
        };
        const touchEndHandler = (e) => {
            if(isMove){
                let nowPoint = e.changedTouches[0].pageX;
                let dis = nowPoint - startPoint.x;
                if (Math.abs(dis) > 100){  //当滑动超过100px时候认为用户想要切换
                    now -= dis/Math.abs(dis);
                };
                x = -now * tabElement.clientWidth;
                picList.style.transition = ".8s";
                picList.style.WebkitTransform = picList.style.transform = `translate3d(${x}px,0,0)`;
                setNav();
            }
            autoPlay();
        };
        const setNav = () => {
            picNavs.forEach((nav)=>{
                nav.classList.remove("active");
            });
            picNavs[now%picNavs.length].classList.add("active");
        }
        const toNext = () => {
            if(now===picList.children.length-1){
                now = picNavs.length -1 ;
                x = -now * tabElement.clientWidth;
                picList.style.transition = "none";
                picList.style.WebkitTransform = picList.style.transform = `translate3d(${x}px,0,0)`;
            }
            setTimeout(() => {
                now ++;
                x = -now * tabElement.clientWidth;
                picList.style.transition = ".8s";
                picList.style.WebkitTransform = picList.style.transform = `translate3d(${x}px,0,0)`;
                setNav();
            }, 30);

        }
        const autoPlay = () => {
            this.timer = setInterval(toNext, 2000);
        }
        // 绑定事件
        tabElement.addEventListener("touchstart", touchStartHandler);
        tabElement.addEventListener("touchmove", touchMoveHandler);
        tabElement.addEventListener("touchend", touchEndHandler);

        autoPlay();
        this.handlers = { touchStartHandler, touchMoveHandler, touchEndHandler };
    }
         componentWillUnmount() {
        // 移除事件监听，防止内存泄漏
        const tabElement = this.tabRef.current;
        if (tabElement && this.handlers) {
            tabElement.removeEventListener("touchstart", this.handlers.touchStartHandler);
            tabElement.removeEventListener("touchmove", this.handlers.touchMoveHandler);
            tabElement.removeEventListener("touchend", this.handlers.touchEndHandler);
        }
        // 清除定时器
        if (this.timer) clearInterval(this.timer);
    }

    render() {
        let {data, className, renderItem} = this.props;
        return (
            <div ref={this.tabRef} className={"tab " + className}>
                <ul className="picList">
                    {data.map((item, index) => (
                        <li key={index}>
                            {renderItem(item)}
                        </li>
                    ))}
                </ul>
                {this.getNav()}
            </div>
        );
    }
    }
